<h1 mat-dialog-title class="single-payment-dialog-heading">
  <span>Single Payment</span>
  <button type="button" mat-icon-button mat-dialog-close aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</h1>

<div mat-dialog-content>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <mat-card class="example-card">
          <mat-card-content>
            <div class="row justify-content-between">
              <div class="col-10">
                <auto-complete [fieldCtrl]="formGroup.get('student')" (optionSelected)="onselect($event)"
                  className="form-control search-bill" placeHolder="Search Student Name | RollNo | Mobile"
                  [list]="Students" [config]="config"></auto-complete>
              </div>
              <div class="col-2">
                <button mat-raised-button small color="primary" class="mt-2 float-left"
                  [disabled]="formGroup.controls.student.invalid">
                  <mat-icon class="icon" (click)="searchStudent()">search</mat-icon>
                </button>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <div class="container mt-5">
    <div class="row">
      <div class="col-12">
        <mat-card class="example-card">
          <mat-card-content>
            <form [formGroup]="formGroup">
              <div class="row">
                <div class="col-md-4">
                  <mat-form-field>
                    <mat-label>Student</mat-label>
                    <input matInput formControlName="name" readonly>
                    <mat-error>
                      <show-errors [control]="formGroup.get('name')"></show-errors>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field>
                    <mat-label>Class</mat-label>
                    <mat-select formControlName="class_id" disabled>
                      <mat-option [value]="class.id"
                        *ngFor="let class of Classes">{{class.name}}</mat-option>
                    </mat-select>
                    <mat-error>
                      <show-errors [control]="formGroup.get('class_id')"></show-errors>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field>
                    <mat-label>Section</mat-label>
                    <mat-select formControlName="section_id" disabled>
                      <mat-option [value]="sec.id" *ngFor="let sec of filteredSections">
                        {{sec.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error>
                      <show-errors [control]="formGroup.get('section_id')"></show-errors>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-4">
                  <mat-form-field>
                    <mat-label>Due Balance</mat-label>
                    <input matInput formControlName="oldbalance" readonly>
                    <mat-error>
                      <show-errors [control]="formGroup.get('oldbalance')"></show-errors>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-4">
                  <mat-form-field>
                    <mat-label>Amount Paid</mat-label>
                    <input matInput formControlName="payedAmount">
                    <mat-error>
                      <show-errors [control]="formGroup.get('payedAmount')"></show-errors>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field>
                    <mat-label>New Balance</mat-label>
                    <input matInput formControlName="newBalance" readonly>
                    <mat-error>
                      <show-errors [control]="formGroup.get('newBalance')"></show-errors>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-4">
                  <mat-form-field>
                    <mat-label>Transaction Date</mat-label>
                    <input matInput formControlName="trans_date" type="date">
                    <mat-error>
                      <show-errors [control]="formGroup.get('trans_date')"></show-errors>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-4">
                  <mat-form-field>
                    <mat-label>Payment Account</mat-label>
                    <mat-select formControlName="account_id">
                      <mat-option *ngFor="let acc of allAccounts" [value]="acc.id">
                        {{ acc.account_name }}
                      </mat-option>
                    </mat-select>
                    <mat-error>
                      <show-errors [control]="formGroup.get('account_id')"></show-errors>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-12">
                  <mat-form-field>
                    <mat-label>Description</mat-label>
                    <textarea matInput formControlName="description"
                      placeholder="Description"></textarea>
                    <mat-error>
                      <show-errors [control]="formGroup.get('description')"></show-errors>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-md-2 col-md-4">
                  <button mat-raised-button small color="primary" class="mt-2 float-right"
                    [disabled]="formGroup.invalid" (click)="submitData()">Submit</button>
                </div>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
